
import { Component } from '@angular/core';

@Component({
    selector: 'app-footer',
    imports: [],
    standalone: true,
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
  copyrightYear: number = new Date().getFullYear();
}
